import sanitizeHtml from 'sanitize-html';

export const htmlToPlainText = (html: string): string => {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {},
  });
};
